export const OFFICE_BACKUP_TAPE_COLUMNS = [
  'media_label',
  'media_set',
  'backup_set',
  'modified_date',
  'tape_type',
  'location',
  'box_number',
  'notes',
  'needs_replacement',
  'damaged',
  'is_new',
] as const;

function csvEscape(value: unknown): string {
  const text = value == null ? '' : String(value);
  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

export function rowsToCsv(headers: readonly string[], rows: Record<string, unknown>[]): string {
  return [headers.join(','), ...rows.map((row) => headers.map((header) => csvEscape(row[header])).join(','))].join('\r\n');
}

export function parseCsv(text: string): Record<string, unknown>[] {
  if (!text) return [];
  const rows: string[][] = [];
  let row: string[] = [];
  let cell = '';
  let quoted = false;
  for (let i = 0; i < text.length; i += 1) {
    const char = text[i];
    if (quoted) {
      if (char === '"' && text[i + 1] === '"') { cell += '"'; i += 1; }
      else if (char === '"') quoted = false;
      else cell += char;
    } else if (char === '"') quoted = true;
    else if (char === ',') { row.push(cell); cell = ''; }
    else if (char === '\n') { row.push(cell); rows.push(row); row = []; cell = ''; }
    else if (char !== '\r') cell += char;
  }
  if (cell || row.length) { row.push(cell); rows.push(row); }
  const headers = (rows.shift() || []).map((header) => header.trim());
  return rows.filter((values) => values.some(Boolean)).map((values) => {
    const result: Record<string, unknown> = {};
    headers.forEach((header, index) => { result[header] = values[index] ?? ''; });
    return result;
  });
}
